import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

// local imports
import successImage from 'assets/images/success-image.svg'
import DateUtil from 'utils/DateUtil'
import { IFilteredGymTrainerList } from 'types/GymType'
import { IFavoriteCampusServices, TCampusServiceType } from 'types/FavoritesType'
import GymService from 'service/GymService'
import NotificationDialog from 'components/ui/NotificationDialog'
import ReservationModalWrapper from 'components/home/on-campus-services/gym/gym-list/trainer/reservation-scheduler/ReservationModal'
import LoadingWrapper from './LoadingWrapper'

/* filtered date - default */
const today = DateUtil.getStartOfDay(new Date())
interface CompProps {
  locationId: number
  id: number
  setReservationType: (type: TCampusServiceType | 0, item: IFavoriteCampusServices | undefined) => () => void
}

export default function GymTrainerRes({ locationId, id, setReservationType }: CompProps) {
  const { t } = useTranslation()
  const history = useHistory()
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(false)
  const [loading, setLoading] = useState(false)
  const [trainerList, setTrainerList] = useState<IFilteredGymTrainerList[] | []>([])

  const openModal = () => setModal(true)
  const closeModal = (resetRes = false) => {
    setModal(false)
    if (resetRes) setReservationType(0, undefined)()
  }
  const closeNotification = () => {
    setNotification(false)
    setReservationType(0, undefined)()
  }

  /* GET Gym Trainer List */
  const getGymGroupLessionList = () => {
    setLoading(true)
    GymService.getFilteredGymTrainerList<IFilteredGymTrainerList>({
      gymTrainerId: 0,
      gymTrainerServiceId: 0,
      trainerServiceTypeIdList: [],
      gymServiceId: 0,
      isEmployeeLocation: false,
      isIncludeNotActives: false,
      locationId: locationId,
      reservationDate: today,
    })
      .then((res) => setTrainerList(res.data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }
  useEffect(() => {
    getGymGroupLessionList()
    openModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, locationId])
  const _selectedTrainer = trainerList.find((r) => r.id === id)
  const [selectedTrainer, setSelectedTrainer] = useState(() => _selectedTrainer)

  if (loading) return <LoadingWrapper />

  return (
    <>
      {/* Gym Trainer Reservation Scheduler Modal */}
      {!!_selectedTrainer ? (
        <ReservationModalWrapper
          trainers={trainerList}
          open={modal}
          openModal={openModal}
          closeModal={closeModal}
          showNotification={() => setNotification(true)}
          selectedTrainer={selectedTrainer || _selectedTrainer}
          setSelectedTrainer={setSelectedTrainer}
          filterDate={today}
        />
      ) : null}

      <NotificationDialog
        display={notification}
        imgSrc={successImage}
        goHomeButton={true}
        title={t('gym-res-modal.notification-title')}
        content={t('gym-res-modal.notification-text')}
        firstButtonLabel={t('buttons.go-to-calendar')}
        onHide={closeNotification}
        onSubmit={() => history.push('/calendar')}
        selectedType={null}
        setSelectedType={undefined}
        types={[]}
      />
    </>
  )
}
